import React, { useRef } from "react"
import gql from "graphql-tag"
import { Query } from "react-apollo"
import { Redirect } from "react-router"
import UpsellModal from "../../components/UpsellModal"

import "./report.scss"

const GET_INTERACTIVE_REPORT = gql`
  query GetInteractiveReport($slug: String!) {
    getInteractiveReport(slug: $slug) {
      id
      name
      url
    }
  }
`

const MarketArrayReport = (props) => {
  const { isUserAuthenticated } = props.viewer

  const authorizationErrorRef = useRef(false)

  const handleQueryError = (error) => {
    if (!error && !authorizationErrorRef.current) return null

    if (
      error.message === "GraphQL error: Not Authorized" ||
      authorizationErrorRef.current
    ) {
      authorizationErrorRef.current = true
      return <UpsellModal />
    }

    return <div>Error while getting market array report.</div>
  }

  if (!isUserAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: props.from || "/market-array" },
        }}
      />
    )
  }

  const paths = props.location.pathname.split("/")
  const slug = paths[paths.length - 1]

  if (!slug) {
    return null
  }

  return (
    <Query
      query={GET_INTERACTIVE_REPORT}
      variables={{ slug: slug }}
      ssr={false}
      fetchPolicy="network-only"
    >
      {({ data, error, loading }) => {
        if (loading) {
          return <div>Loading...</div>
        }

        const errorComponent = handleQueryError(error)
        if (errorComponent) {
          return errorComponent
        }

        if (data && data.getInteractiveReport) {
          return (
            <div className="market-array-report-container">
              <iframe
                id={data.getInteractiveReport.slug}
                src={data.getInteractiveReport.url}
              ></iframe>
            </div>
          )
        }

        return <Redirect to="/not-found" />
      }}
    </Query>
  )
}

export default MarketArrayReport
